module.exports = __webpack_public_path__ + "static/4-fbaa863fda6bd47524333d598a7c67ae.woff2";